<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item v-if="user && ![2, 3, 4, 5].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :page="page" :limit="limit"
      :total="total" :showIndex="true" :btns="btns" :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" >

      <!-- 是否含税 -->
      <template slot="is_tax" slot-scope="params">
        {{ params.params.is_tax == 1 ? '是' : '否' }}
      </template>

    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'contract',
      formInline: {
        isstatus: 4,
      },
      formCtrl: [
        {
          label: "合同编号",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
        {
          label: "客户名称",
          keyName: "shname",
          placeholder: "请填写客户名称",
          type: "text",
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          placeholder: "请填写装货地址",
          type: "text",
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          placeholder: "请填写卸货地址",
          type: "text",
        },
      ],
      cols: [
        { prop: "con_num", label: "合同编号", minwidth: 120 },
        { prop: "shname", label: "客户名称" },
        { prop: "name", label: "货物名称" },
        { prop: "coaddress", label: "装货地址" },
        { prop: "enaddress", label: "卸货地址" },
        //{ prop: "starttime", label: "开始时间" },
        { prop: "cprice", label: "公司单价", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "ton", label: "运送重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "inton", label: "装货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "unton", label: "卸货重量", align: 'right', className: 'pr30', width: 120 },
        { prop: "is_tax", label: "是否含税", slot: 'is_tax' },
      ],
      allBtnWidth: 128,
      btns: [
        {
          title: '查看统计',
          img: require('@/assets/img/icon_count.png'),
          unimg: require('@/assets/img/icon_count_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/contract/statistics?id=${id}`
            );
          },
        },
        {
          title: '订单列表',
          //icon: 'el-icon-s-order',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ id }) => {
            this.$router.push(
              `/contract/orderlist?id=${id}`
            );
          },
        },
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/detail?id=${id}&mode=view`
            );
          },
        },
      ],
      baseParams: ['isstatus'],
    };
  },
  methods: {
    add() {
      this.$router.push(
        `/contract/detail?mode=add`
      );
    },
  },
  mounted() {
    this.getList()
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}
</style>
